import {type Submission} from '@/api/submissions';

const RESTRICTIONS: Array<[key: string, label: string]> = [
  ['age_restricted', 'Age-restricted'],
  ['content_warning', 'Warning'],
  ['region_restricted', 'Region-restricted'],
  ['access_restricted', 'Playback restricted']
];

// The action the platform has taken on a delivered submission, from our own re-checks, most severe
// first. Empty when none is seen. A PRI-side withdrawal (action_status "removed") is not one.
export function enforcementActions(sub: Pick<Submission, 'platform_status' | 'platform_changes'>) {
  const changes = sub.platform_changes ?? [];
  return [
    ...(sub.platform_status === 'removed' ? ['Removed'] : []),
    ...RESTRICTIONS.filter(([key]) => changes.includes(key)).map(([, label]) => label)
  ];
}
